import * as bd from 'react-basic-design';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AccountProvider } from './app/account-context';
import { store } from './app/stores/store';
import { ThemeProvider } from './app/theme-context';
import { T } from './components/basic/text';
import { ErrorProvider } from './components/error-handler/error-handling';
import { TProvider } from './i18n';
import { AppRoutes } from './routes';

function App() {
    return (
        <ErrorProvider>
            <Provider store={store}>
                <TProvider>
                    <ThemeProvider>
                        <>
                            <BrowserRouter>
                                <AccountProvider>
                                    <AppRoutes />
                                </AccountProvider>
                            </BrowserRouter>
                            <bd.MsgBoxContainer />
                            <ToastContainer
                                rtl={false}
                                limit={3}
                                position="bottom-right"
                                autoClose={6000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                            />
                            <div id="_Progress_Tracker_" className="d-none">
                                <div className="fade modal-backdrop show opacity-75"></div>
                                <div className="fade modal show d-block d-flex align-items-center justify-content-center text-white">
                                    <div className="text-center">
                                        <div className="lds-ripple">
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <T as="div">please-wait</T>
                                    </div>
                                </div>
                            </div>
                        </>
                    </ThemeProvider>
                </TProvider>
            </Provider>
        </ErrorProvider>
    );
}

export default App;
